module.exports = __webpack_public_path__ + "static/media/trigger-data.0dcc5247.svg";